import { AxiosInstance } from 'axios';
import { CreateTaskIssueInput, ResolveTaskIssueInput } from './inputs';
import { TaskIssueRef } from './refs';

export default class TaskIssue {
    private basePath = '/api/task-issue';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Creates new task issue
    create = async (input: CreateTaskIssueInput): Promise<TaskIssueRef> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);
        return data;
    };

    // Resolves task issue
    resolve = async (id: ID, input: ResolveTaskIssueInput): Promise<TaskIssueRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}/resolve`, input);

        return data;
    };
}
